module.exports = __webpack_public_path__ + "static/img/k7.1723263d.png";